import { Col, Container, Row, Spinner, Alert } from "react-bootstrap";
// New package button
import { Button } from '@veeyaainnovatives/button';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Banner } from '@veeyaainnovatives/banner';
import Bannerimg from '../assets/images/gallery/gallery-3.jpg';
import Enrollment from "../components/sections/enrollment";
import axios from 'axios';
import { getApiUrl } from '../config/api';

const VaastuHousePlans = () => {
    const navigate = useNavigate();
    const [pdfList, setPdfList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Fetch PDF downloads from API
    useEffect(() => {
        const fetchPdfDownloads = async () => {
            try {
                setLoading(true);
                setError('');
                
                const response = await axios.get(getApiUrl('api/public/pdf-downloads'));
                
                if (response.data.success && response.data.data) {
                    // Map API response to component structure
                    const mappedPdfs = response.data.data.map(pdf => ({
                        id: pdf.id,
                        name: pdf.title || pdf.file_name,
                        url: pdf.file_url,
                        description: pdf.short_description || `Download ${pdf.file_name}`,
                        file_name: pdf.file_name,
                        file_size: pdf.file_size
                    }));
                    
                    setPdfList(mappedPdfs);
                } else {
                    setPdfList([]);
                }
            } catch (error) {
                console.error('Error fetching PDF downloads:', error);
                setError('Failed to load PDF downloads. Please try again later.');
                setPdfList([]);
            } finally {
                setLoading(false);
            }
        };

        fetchPdfDownloads();
    }, []);

    const handleDownload = (pdf) => {
        if (pdf.url && pdf.url !== "#") {
            // Open PDF in new tab
            window.open(pdf.url, '_blank');
        } else {
            // If PDF URL is not set, show message
            alert(`PDF "${pdf.name}" is not available. Please contact us for more information.`);
        }
    };

    const pageDetails = {
        title: "Download Your Free PDF: **20 Vaastu House Plans**",
        description: "Get access to 20 professionally designed Vaastu-compliant house plans. Download your free PDFs today!",
        breadcrumb: [
            { name: "Home", link: "/" },
            { name: "Vaastu House Plans", link: "/vaastu-house-plans" }
        ],
    };

    return (
        <>
            <Banner img={Bannerimg} pageDetails={pageDetails} highlightClassName="theme-color-green" />
            <div className="body-wrap overflow-hidden mt-5">
                <section className='py-5'>
                    <Container>
                        <div className="text-center mb-5">
                            <h2 className="creative-learning-title mb-3">
                                Free Vaastu House Plans Collection
                            </h2>
                            <p className="creative-learning-desc">
                                Explore our collection of professionally designed Vaastu-compliant house plans. 
                                Each plan is carefully crafted to ensure positive energy flow and harmony in your home.
                            </p>
                        </div>

                        {/* Loading State */}
                        {loading && (
                            <div className="text-center py-5">
                                <Spinner animation="border" role="status" style={{ color: '#677a58' }}>
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                                <p className="mt-3">Loading PDF downloads...</p>
                            </div>
                        )}

                        {/* Error State */}
                        {error && (
                            <Alert variant="danger" className="mb-4">
                                <Alert.Heading>Error</Alert.Heading>
                                <p>{error}</p>
                            </Alert>
                        )}

                        {/* PDF List */}
                        {!loading && !error && (
                            <>
                                {pdfList.length > 0 ? (
                                    <Row className="g-4">
                                        {pdfList.map((pdf) => (
                                            <Col lg={3} md={6} key={pdf.id}>
                                                <div className="pdf-card">
                                                    <div className="pdf-card-icon">
                                                        <span className="fas fa-file-pdf"></span>
                                                    </div>
                                                    <div className="pdf-card-content">
                                                        <h3 className="pdf-card-title">{pdf.name}</h3>
                                                        <p className="pdf-card-description">{pdf.description}</p>
                                                        <div className="pdf-card-actions">
                                                            <Button
                                                                className="home-button pdf-download-btn"
                                                                backgroundColor="#677a58"
                                                                color="#ffffff"
                                                                hoverBackgroundColor="#5a6a4a"
                                                                padding="13px 40px"
                                                                fontSize="16px"
                                                                fontWeight="500"
                                                                borderRadius="100px"
                                                                onClick={() => handleDownload(pdf)}
                                                            >
                                                                <span className="fas fa-download"></span>
                                                                <span>Download</span>
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                ) : (
                                    <div className="text-center py-5">
                                        <p className="text-muted">No PDF downloads available at the moment.</p>
                                    </div>
                                )}
                            </>
                        )}
                    </Container>
                </section>

                <section className="section">
                    <Enrollment 
                        title={'Contact us if you want custom plan'} 
                        description={'One team. One platform. One studio for design, approvals, construction, and interiors.'} 
                        btns={['whatsapp', 'estimation']} 
                    />
                </section>
            </div>
        </>
    );
};

export default VaastuHousePlans;

